import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/hub/components/sideButton/sideButton.sss';

export default class SideButton extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false
		};
	}

	componentDidMount() {
		this.delaySideButton = setTimeout(() => {
			this.setState({
				visible: true
			});
		}, 300);
	}

	componentWillUnmount() {
		window.clearTimeout(this.delaySideButton);
	}

	render() {
		const { data } = this.props;
		const { icon, label, link, invertColor } = data;
		const { visible } = this.state;
		const imgStyle = { filter: invertColor ? 'invert(1)' : '' };

		return (
			<div class={joinClasses(s.sideButtonContainer, visible && s.visible)}>
				<a class={s.link} href={link} target="_blank">
					<span class={joinClasses(s.label, 'xlargeB')}>{label}</span>
					<img style={imgStyle} class={s.icon} src={icon} />
				</a>
			</div>
		);
	}
}
